import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import HomePage from './Homepage';
import PrivacyPage from './PrivacyPolicy';
import {Footer} from "./Footer";
import Contact from "./Contact";
import Header from "./Header";
import {Container, Grid} from "@mui/material";
import Terms from "./Terms";
import DataDeletion from "./DataDeletion";

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <Header/>
            <Container fixed={true}>
                <Grid container marginTop={4}>
                    <Grid item xs={12}>
                        <Routes>
                            <Route path="/" element={<HomePage/>}/>
                            <Route path="/privacy-policy" element={<PrivacyPage/>}/>
                            <Route path="/contact" element={<Contact/>}/>
                            <Route path="/terms" element={<Terms/>}/>
                            <Route path="/data-deletion" element={<DataDeletion/>}/>
                        </Routes>
                    </Grid>
                </Grid>
            </Container>
            <Footer/>
        </BrowserRouter>
    );
}

export default App;
